import React, { useState, useEffect, useMemo, useRef } from "react";
import FullScreenLoader from "../Components/FullScreenLoader"; // Loader component

export default function HollMatches({ selectedVenue, selectedDate, setLoadingState }) {
  const [matchesData, setMatchesData] = useState([]);
  const [loading, setLoading] = useState(true); // Internal loader state

  // Stable, memoized URL
  const venue_schedule_api_url = useMemo(
    () =>
      `https://us-central1-hsf-production-505a6.cloudfunctions.net/webApi/venues/${selectedVenue}/schedule?from=${selectedDate}&days=100`,
    [selectedVenue, selectedDate]
  );

  // Keep refs for timeout and stop guard
  const stopTimeoutRef = useRef(null);

  useEffect(() => {
    const controller = new AbortController();
    let stopped = false;  // prevent double stop
    let started = false;  // did we call setLoadingState(true)?

    const stop = () => {
      if (stopped) return;
      stopped = true;
      if (stopTimeoutRef.current) {
        clearTimeout(stopTimeoutRef.current);
        stopTimeoutRef.current = null;
      }
      setLoading(false);
      if (started) setLoadingState(false);
    };

    const fetchData = async () => {
      // START (always balance this)
      setLoading(true);
      setLoadingState(true);
      started = true;

      try {
        const response = await fetch(venue_schedule_api_url, { signal: controller.signal });
        const data = await response.json();
        setMatchesData(Array.isArray(data?.schedule) ? data.schedule : []);
      } catch (error) {
        if (error?.name !== "AbortError") {
          console.error("Error fetching data:", error);
        }
        // AbortError is expected on fast switches; cleanup will STOP.
      } finally {
        // Smooth fade; cleanup clears this if needed
        stopTimeoutRef.current = setTimeout(() => {
          stop();
        }, 300);
      }
    };

    fetchData();

    // Cleanup ALWAYS balances the START:
    // - abort the fetch
    // - clear pending timeout
    // - ensure loader stops if finally didn't run yet
    return () => {
      controller.abort();
      stop();
    };
  }, [venue_schedule_api_url, setLoadingState]);

  const convertDate = (seconds) => {
    const date = new Date(seconds * 1000);
    return date.toLocaleDateString("fo-FO", {
      weekday: "long",
      day: "2-digit",
      month: "long",
      year: "numeric",
    });
  };

  let previousDate = null;

  return (
    <>
      {loading && <FullScreenLoader />} {/* Loader while fetching data */}

      <section className="venue-matches">
        <div>
          <div>
            <div>
              <table className="table">
                <tbody>
                  {matchesData.map((match) => {
                    const currentDate = convertDate(match.date._seconds);
                    const shouldCreateNewTable = currentDate !== previousDate;
                    previousDate = currentDate;

                    return (
                      <React.Fragment key={match.id}>
                        {shouldCreateNewTable && (
                          <tr className="vendate">
                            <td colSpan="7" className="venue-date">
                              {currentDate}
                            </td>
                          </tr>
                        )}

                        <tr
                          title="heinta dómaraseðil"
                          className={match.matchReport ? "hover played" : ""}
                          onClick={() => {
                            if (match.matchReport) {
                              window.open(match.matchReport, "_blank");
                            }
                          }}
                        >
                          <td className="left-align venue-clock">
                            {match.time}
                            <div className="justsmall">{match.group.name}</div>
                          </td>
                          <td className="left-align venue-league">
                            <div className="matchGroupName">{match.group.name}</div>
                            <div className="matchVenueName">
                              {match.matchReport && (
                                <img
                                  title="heinta dómaraseðil"
                                  className="pdfimg"
                                  alt=""
                                  src="/pdf.png"
                                />
                              )}
                            </div>
                          </td>
                          <td className="right-align match-team-name">{match.homeTeam.name}</td>
                          <td className="match-team-logo center-align venue-team-logo">
                            <img
                              src={`https://files.hsf.fo/clubs/${match.homeTeam.clubId}.webp`}
                              alt="Team 1 Logo"
                            />
                          </td>
                          <td className="dash">
                            {match.result?.home.goalsFor}-{match.result?.away.goalsFor}
                          </td>
                          <td className="match-team-logo center-align venue-team-logo">
                            <img
                              src={`https://files.hsf.fo/clubs/${match.awayTeam.clubId}.webp`}
                              alt="Team 2 Logo"
                            />
                          </td>
                          <td className="left-align match-team-name">{match.awayTeam.name}</td>
                        </tr>
                      </React.Fragment>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
